"use client";

import { NomineesContextProvider } from "./contexts/nomination";
import MainContent from "./main-content";
import TopBar from "./top-bar";
import { Categories } from "@/types";
import { Shell } from "../ui/shell";
import Carpet from "../ui/Carpet";

type Props = {
  categories: Categories[];
};

export default function NominationContent({ categories }: Props) {
  return (
    <NomineesContextProvider categories={categories}>
      <Carpet type="fade-light-to-dark" className="!pb-32 !pt-20">
        <div className="flex pb-10 pt-32 sm:pb-20 sm:pt-40 lg:pb-28 2xl:pb-32">
          <Shell className="!py-0">
            <TopBar />
          </Shell>
        </div>
        <div className="mx-auto pb-20 lg:pb-32 2xl:max-w-[80%]">
          <MainContent />
        </div>
      </Carpet>
    </NomineesContextProvider>
  );
}
